import services from "../../../libs/services";

export class SmoothScrollItem {
    constructor({el}) {
        this.DOM = {el};
        this.prop = {};
    }

    getProp() {
        this.resetStyle();
        setTimeout(() => {
            const {top, bottom} = this.DOM.el.getBoundingClientRect();

            this.prop.top = top;
            this.prop.bottom = bottom;
        }, 1);
    }

    handleScrolling(instance) {
        const disTop = this.prop.top + instance;
        const disBottom = this.prop.bottom + instance;
        const trigger = services.winSize.height * 1.35;

        if (disTop < trigger) {

            const max = (this.prop.bottom + trigger);
            const y = Math.max(-max, Math.min(instance, 0));

            this.DOM.el.style.transform = `translate3d(0, ${y}px, 0)`;
        }
    }

    resetStyle() {
        this.DOM.el.style.transform = null;
    }
}